<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 草稿列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="title">草稿箱</div>
			<div class="handle-box">
				<!-- <el-input placeholder="新闻名称" class="handle-input mr10" v-model="menuName" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button> -->
				<el-button type="primary" icon="el-icon-circle-plus-outline" @click="createPerson">创建新闻</el-button>
			</div>
			<el-table :data="personList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				v-loading="isloading" style="width: 100%">
				<!-- <el-table-column prop="Id" label="ID" align="center" fixed></el-table-column> -->
				<el-table-column prop="content.news_item[0].title" label="标题" align="center" fixed></el-table-column>
				<el-table-column prop="content.news_item[0].author" label="作者" align="center" fixed></el-table-column>
				<el-table-column prop="content.news_item[0].thumb_url" label="图片" align="center" fixed>
					<template #default="scope">
						<a :href="scope.row.content.news_item[0].thumb_url" target="_blank">
							<el-image class="table-td-thumb" :src="scope.row.content.news_item[0].thumb_url"
								:preview-src-list="scope.row.content.news_item[0].thumb_url">
							</el-image>
						</a>
					</template>
				</el-table-column>
				<el-table-column prop="content.create_time" label="时间" align="center" fixed></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<el-button type="text" @click="handleDelete(scope.row)" style="color: red;">群发
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="pagination">
				<el-pagination background layout="total, prev, pager, next,sizes" :current-page="pageIndex"
					@size-change="handleSizeChange" :page-size="pageSize" :total="pageTotal"
					@current-change="handlePageChange" :page-sizes="[5, 10, 15,20]"></el-pagination>
			</div> -->
		</div>

		<el-dialog title="提示" v-model="isdelete" width="30%">
			<span>您确定删除吗？</span>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="isdelete = false">取 消</el-button>
					<el-button type="primary" @click="deleteNews">确 定</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 创建 -->
		<el-dialog :title="title" v-model="createDialog" width="30%">
			<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
				<el-form-item prop="HeadPhoto" label="预览图">
					<el-image
						style="width: 360px; height: 150px;display: flex;align-items: center;justify-content: center;background-color: #eee;"
						:src="ruleForm.HeadPhoto" fit="cover" @click='changeHeadphoto'><template #error
							class="image-slot">
							<i class="el-icon-picture-outline"></i>
						</template></el-image>
					<el-upload class="upload-demo" limit="1" :file-list="fileList" :before-upload="beforeAvatarUpload"
						style="width: 100px;">
						<el-button size="small" type="primary" ref="aa" style="width: 100px!important;" v-if="title=='查看'?false:true">点击上传</el-button>
					</el-upload>
					<span style="font-weight: bold;color: red;" v-if="title=='查看'?true:false">由于微信对图片进行限制，点击此<a :href="ruleForm.HeadPhoto" target="_blank">链接</a>查看</span><br>
					<span style="font-weight: bold;color: red;" v-if="title=='查看'?false:true">预览图尺寸360*150像素</span>
				</el-form-item>
				<el-form-item label="标题" prop="title">
					<el-input v-model="ruleForm.title" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item label="作者" prop="author">
					<el-input v-model="ruleForm.author" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item label="简介" prop="digest">
					<el-input v-model="ruleForm.digest" :disabled="isdisabled"></el-input>
				</el-form-item>
				<el-form-item label="新闻内容" prop="Introduction">
					<!-- <el-input v-model="ruleForm.Introduction" :disabled="isdisabled"></el-input> -->
					<wenben :Introduction='ruleForm.Introduction' :isbianji='iseditor' @childvalue='childvalue'
						ref="mychild"></wenben>
				</el-form-item>
			</el-form>
			<template #footer v-if="title=='查看'?false:true">
				<span class="dialog-footer">
					<el-button @click="createDialog = false" :disabled="isdisabled">取 消</el-button>
					<el-button type="primary" @click="create('ruleForm')" :disabled="isdisabled" >确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	import wenben from '../components/wenben.vue'
	import E from 'wangeditor'
	export default {
		components: {
			wenben
		},
		data() {
			return {
				createDialog: false,
				isloading: true,
				isdelete: false, //删除弹出框
				deleteid: '',
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				name: '',
				menuName: '',
				isdisabled: false,
				ruleForm: '',
				title: '',
				editVisible: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				personList: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
				menuId: '',
				iseditor: false,
				rules: {
					Name: [{
						required: true,
						message: '请输入新闻名称',
						trigger: 'blur'
					}],
					Author: [{
						required: true,
						message: '请输入新闻作者',
						trigger: 'change'
					}],
					Source: [{
						required: true,
						message: '请输入新闻来源',
						trigger: 'blur'
					}],
					State: [{
						required: true,
						message: '请选择标签',
						trigger: 'change'
					}],
				},
				newsTagList: []
			}
		},
		created() {
			this.getNewsTag()
			this.getmenuId()
			this.getData()
		},
		methods: {
			//上传头像
			beforeAvatarUpload(file) {
				console.log(file)
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 1
				console.log(isLt2M)
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过1M!')
				} else if (type != 'jpg' && type != 'png') {
					this.$message.error('上传图片必须是  jpg / png  格式!');
				} else {
					let formdata = new FormData()
					formdata.append('file', file)
					axios({
						method: 'post',
						url: this.$store.state.wx + 'WXImgUpload',
						data: formdata,
						headers: {
							Authorization: 'bearer ' + this.token
						}
					}).then((res) => {
						console.log(res.data.Data)
						if (res.data.Message == '请求成功') {
							this.ruleForm.HeadPhoto = res.data.Data[0].url
							axios({
								method: 'post',
								url: this.$store.state.wx + "UpLoadMaterial?webUrl=" + this.ruleForm
									.HeadPhoto + '&materialType=image',
							}).then((ress) => {
								if (ress.data.Data.media_id) {
									this.ruleForm.thumb_media_id = ress.data.Data.media_id
								} else {
									this.$message.error('该图片不符合微信上传图片的格式，请重新上传')
									this.ruleForm.HeadPhoto = ''
									this.ruleForm.thumb_media_id = ''
								}
							})
						} else {
							this.$message.error('上传失败！')
						}
					})
				}
			},
			changeHeadphoto() {
				console.log('666')
				this.$refs.aa.click()
			},
			getLocalTime(d) {
				var date = new Date(d);
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				month = month < 10 ? "0" + month : month;
				day = day < 10 ? "0" + day : day;
				d = year + '-' + month + '-' + day;
				return d
			},
			getNewsTag() {
				axios({
					method: 'get',
					url: this.$store.state.url + "GetNewsTag",
				}).then((res) => {
					this.newsTagList = res.data.Data
				})
			},
			//删除
			handleDelete(row) {
				console.log(row)
				this.$confirm('是否要群发?', '每月只可以发送4条', {
					confirmButtonText: '是',
					cancelButtonText: '否',
					type: 'warning'
				}).then(() => {

					axios({
						method: 'post',
						url: this.$store.state.wx + "SendArticleByGroup?media_id=" + row.media_id,
					}).then((res) => {
						console.log(res)
						if (res.data.Data.ErrCode == 0) {
							this.$message({
								type: 'success',
								message: '此信息已提交，待微信官方审核后即可收到信息'
							});
						} else {
							this.$message({
								type: 'info',
								message: '群发失败'
							});
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消群发'
					});
				});
			},
			deleteNews() {
				axios({
					method: 'post',
					url: this.$store.state.pcurl + "DeleteNew?newsId=" + this.deleteid,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.isdelete = false
						this.$message({
							message: '删除新闻成功！',
							type: 'success'
						})
						this.getData()
					} else {
						this.$message.error('删除新闻失败！');
					}
				})
			},
			childvalue(val) {
				console.log(val)
				this.ruleForm.Introduction = val
				this.ruleForm.content = val
			},
			//获取id
			getmenuId() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetMenu",
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					res.data.Data.forEach((x) => {
						if (x.Name == '新闻活动') {
							this.menuId = x.Id
							console.log(x)
						}
					})
					console.log(this.menuId)
				})
			},
			//搜索新闻
			handleSearch() {
				this.name = this.menuName
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getData()
			},
			//创建新闻
			createPerson() {
				this.title = '创建新闻'
				this.ruleForm = []
				this.isdisabled = false
				this.iseditor = true
				this.createDialog = true
				this.ruleForm.Introduction = ''
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.createDialog = true
				this.ruleForm = row.content.news_item[0]
				this.ruleForm.Introduction = row.content.news_item[0].content
				this.ruleForm.HeadPhoto = row.content.news_item[0].thumb_url
			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.iseditor = false
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetNewsModel?newsId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			create(ruleForm) {
				this.$refs[ruleForm].validate((valid) => {
					if (valid) {
						this.$refs.mychild.syncHTML()
						var arr = []
						var obj = {
							thumb_media_id: this.ruleForm.thumb_media_id,
							author: this.ruleForm.author,
							title: this.ruleForm.title,
							content: this.ruleForm.content,
							digest: this.ruleForm.digest,
						}
						arr.push(obj)
						axios({
							method: 'post',
							url: this.$store.state.wx + "AddArticle",
							data: arr,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								this.createDialog = false
								this.$message({
									message: '创建成功',
									type: 'success'
								})
								this.getData()
							} else {
								this.$message.error('创建失败');
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							this.$refs.mychild.syncHTML()
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateNews",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			},
			getData() {
				axios({
					method: 'get',
					url: this.$store.state.wx + "GetArticleList",
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Data) {
						this.isloading = false
						this.pageTotal = res.data.Data.item_count
						this.personList = res.data.Data.item
						this.personList.forEach((x) => {
							x.content.create_time = this.getLocalTime(x.content.create_time*1000)
							x.dian = x.content.news_item[0].thumb_url.lastIndexOf('?')
							x.content.news_item[0].thumb_url = x.content.news_item[0].thumb_url
								.slice(0, x
									.dian - 1)
						})
					}
				})
			},
		}
	};
</script>

<style scoped lang="less">
	.title {
		width: 100%;
		height: 120px;
		font-size: 36px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.container {
		padding-top: 0;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(iframe) {
		height: 600px;
	}

	:deep(.el-upload) {
		width: 100px;
		height: 38px;
		border: none;
	}
</style>
